export const buildContactEntries = (collection, getValue, primaryId) => {
  if (!collection) return [];

  const entries = collection.render((item) => ({
    id: item.id(),
    value: getValue(item),
    isPrimary: item.id() === primaryId,
  }));

  return entries
    .filter((entry) => entry.value)
    .sort((a, b) => Number(b.isPrimary) - Number(a.isPrimary));
};

export const extractUserCustomerData = (userCustomer) => {
  if (!userCustomer) {
    return {
      emails: [],
      phones: [],
      roles: [],
      labels: [],
      hasContact: false,
    };
  }

  const emails = buildContactEntries(
    userCustomer.emailAddresses?.(),
    (e) => e.getEmailAddress?.(),
    userCustomer.getPrimaryEmailAddressRelation?.()?.id,
  );

  const phones = buildContactEntries(
    userCustomer.phoneNumbers?.(),
    (p) => p.getNumber?.(),
    userCustomer.getPrimaryPhoneNumberRelation?.()?.id,
  );

  const roleCollection = userCustomer.roles?.();
  const roles = roleCollection
    ? roleCollection
        .render((role) => ({
          id: role.id(),
          name: role.getDisplayName?.() || role.getName?.() || role.id(),
          isExonet: !role.hasCustomerRelation?.(),
        }))
        .filter((role, i, arr) => arr.findIndex((r) => r.id === role.id) === i)
    : [];

  return {
    emails,
    phones,
    roles,
    hasContact: emails.length > 0 || phones.length > 0,
  };
};
